//class
import PadCreator from '../PadCreator';
import BuildPadVisit from './BuildPadVisit';
// utils
import _ from 'lodash';
import { codeGeneretor, keepObjectProperties } from 'app/utils';
// config
// import { PAD_CARD_TYPES } from 'app/config/pad';
import { PAD_ALTERATION_TYPE } from 'app/config/pad';

const { CREATION, ALTERATION } = PAD_ALTERATION_TYPE;

/**
 * represents an instance of PadVisit
 * @class PadVisit
 * @extends PadCreator
 */
export default class PadVisit extends PadCreator {
  prepare(padVisits, padVisitType) {
    const preparedPadVisits = padVisits.map(padVisit => {
      const code = codeGeneretor();

      return (
        new BuildPadVisit(padVisit)
          .cleanPadVisit(keepObjectProperties)
          .addPadVisitType(padVisitType)
          // .addPadCardType(PAD_CARD_TYPES.VISIT)
          .addPadVisitCode(code)
          .addStatus(1)
          .getPadVisit()
      );
    });

    this._loadedData = _.cloneDeep(preparedPadVisits);
    this._screenData = _.cloneDeep(preparedPadVisits);

    return this;
  }

  /**
   * add a new pad visit.
   * @param {object} padVisit - padVisit to be added.
   * @returns {object} the state
   */
  add(padVisit) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const code = codeGeneretor();

    const padVisitToAdd = new BuildPadVisit(padVisit)
      .addPadVisitType(CREATION)
      .addPadVisitCode(code)
      .addStatus(1)
      // .addPadCardType(PAD_CARD_TYPES.VISIT)
      .getPadVisit();

    this._screenData = [...cScreenData, padVisitToAdd];
    this._submitData = [...cSubmitData, padVisitToAdd];

    return this;
  }

  /**
   * update a pad visit.
   * @param {object} padVisit - padVisit to be edited.
   * @returns {object} return the state
   */
  edit(padVisit) {
    const screenData = _.cloneDeep(this._screenData);
    const submitData = _.cloneDeep(this._submitData);

    const nPadVisit = new BuildPadVisit(padVisit).setUpdateStatus().getPadVisit();

    const indexScreen = screenData.findIndex(pVisit => pVisit.code === nPadVisit.code);
    screenData.splice(indexScreen, 1, nPadVisit);

    const indexSubmit = submitData.findIndex(pVisit => pVisit.code === nPadVisit.code);
    submitData.splice(indexSubmit, 1, nPadVisit);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * change a element.
   * @param {object} padVisit - padVisit to be changed.
   * @returns {object} return the state
   */
  change(padVisit) {
    const cPadVisit = { ...padVisit, itHasBeenUpdated: true };

    cPadVisit.padVisitAlterId = padVisit.id;
    cPadVisit.padVisitType = ALTERATION;

    const screenData = _.cloneDeep(this._screenData);
    const submitData = _.cloneDeep(this._submitData);

    const indexScreen = screenData.findIndex(pVisit => pVisit.code === padVisit.code);
    screenData.splice(indexScreen, 1, cPadVisit);

    let indexSubmit = submitData.findIndex(pVisit => pVisit.code === padVisit.code);
    const somethingWasFound = indexSubmit !== -1;
    indexSubmit = somethingWasFound ? indexSubmit : submitData.length;
    submitData.splice(indexSubmit, 1, cPadVisit);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * remove a element.
   * @param {object} padVisit - padVisit to be removed.
   * @returns {object} return the state
   */
  remove(padVisit) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const screenData = cScreenData.filter(pVisit => pVisit.code !== padVisit.code);
    const submitData = cSubmitData.filter(pVisit => pVisit.code !== padVisit.code);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * suspend a pad visit.
   * @param {object} padVisit - padVisit to be suspended.
   * @returns {object} return the state
   */
  suspend(padVisit) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const screenData = cScreenData.map(pVisit => {
      if (pVisit.id === padVisit.id) {
        return new BuildPadVisit(padVisit).suspendPadVisit(padVisit.id).getPadVisit();
      }
      return pVisit;
    });

    const pVisit = screenData.find(pVisit => pVisit.code === padVisit.code);

    const submitData = [...cSubmitData, pVisit];

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * unsuspend a pad visit.
   * @param {object} padVisit - padVisit to be unsuspended.
   * @returns {object} return the state
   */
  unsuspend(padVisit) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const screenData = cScreenData.map(pVisit => {
      if (pVisit.id === padVisit.id) {
        return new BuildPadVisit(padVisit).unsuspendPadVisit().getPadVisit();
      }
      return pVisit;
    });

    const submitData = cSubmitData.filter(pVisit => pVisit.code !== padVisit.code);

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }

  /**
   * unsuspend a pad visit.
   * @param {object} padVisit - padVisit to be unsuspended.
   * @returns {object} return the state
   */
  applyPredefinedPadVisitModel(padVisit) {
    const cScreenData = _.cloneDeep(this._screenData);
    const cSubmitData = _.cloneDeep(this._submitData);

    const code = codeGeneretor();

    const padVisitToAdd = new BuildPadVisit(padVisit)
      .addPadVisitType(CREATION)
      .addPadVisitCode(code)
      .addStatus(1)
      // .addPadCardType(PAD_CARD_TYPES.VISIT)
      .getPadVisit();

    const screenData = [...cScreenData, padVisitToAdd];
    const submitData = [...cSubmitData, padVisitToAdd];

    this._screenData = _.cloneDeep(screenData);
    this._submitData = _.cloneDeep(submitData);

    return this;
  }
}
